import React from 'react';
import classNames from 'classnames';
import { CellItem, RowSelect } from '.';
export const RowComponent = ({ items, className = '', columns, gridID, onRowSelect, canSelectRow, rowID = -1, selectionDisabled, columnTypes, isSelected, showDashIfEmpty = true, onRowClick, }) => {
    const selectedClass = isSelected ? 'table_row--selected' : '';
    const operatorCategoryClass = items.metaData && items.metaData.operatorCategory
        ? 'operatorcategory--' + items.metaData.operatorCategory.toLowerCase().trim().replace(/\s+/g, '-')
        : '';
    return (React.createElement("tr", { className: classNames('table_row', className, operatorCategoryClass, selectedClass), onClick: onRowClick },
        canSelectRow && RowSelect({ onRowSelect, gridID, isSelected, rowID, selectionDisabled }),
        items &&
            columns.map(column => {
                const shortVersion = items ? items[`${column}-short`] : '';
                const item = {
                    long: items[column],
                    short: shortVersion ? shortVersion : '',
                };
                return CellItem(column, item, gridID, rowID, columnTypes, showDashIfEmpty);
            })));
};
//# sourceMappingURL=RowComponent.js.map